export enum PeacockEvent {
  SessionStart = 'session_start',
  SignUp = 'sign_up',
  Purchase = 'purchase',
}

export interface PeacockApi {
  sendConversion: (event: PeacockEvent) => void;
}
